module.exports = __webpack_public_path__ + "static/media/freesample-banner.41890856.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/papertypes/freesample-banner.svg
// module id = 1480
// module chunks = 51